// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"42c65afb","677":"b5acb78d","730":"6c5871fb","883":"848811a7","996":"05a47a78"}[chunkId] + ".chunk.css";
};